import { Component, OnInit, Input } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { ModalController, RadioGroupChangeEventDetail } from '@ionic/angular';
import { City } from 'src/app/interfaces/api/city';
import { ProductService } from 'src/app/services/product.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-modal-select-city-branch',
  templateUrl: './modal-select-city-branch.component.html',
  styleUrls: ['./modal-select-city-branch.component.scss'],
})
export class ModalSelectCityBranchComponent implements OnInit {
  cities: City[];
  hasSelectedCity: City;
  selectedCity: City;
  isLoading = true;

  constructor(private modalController: ModalController, private productService: ProductService) {}

  async ngOnInit() {
    this.hasSelectedCity = JSON.parse((await Preferences.get({ key: 'selectedCity' })).value);
    this.selectedCity = this.hasSelectedCity;
    this.loadData(null);
  }

  loadData(event) {
    this.isLoading = true;
    const citiesReq = this.productService.getWarehouseCities();

    forkJoin([citiesReq]).subscribe({
      next: async ([citiesRes]) => {
        this.cities = citiesRes.cities;
      },
      complete: () => {
        this.isLoading = false;
        event?.target?.complete();
      },
    });
  }

  radioChangeHandler(event: Event) {
    const customEvent = event as CustomEvent<RadioGroupChangeEventDetail>;
    const selectedId = customEvent.detail.value;
    this.selectedCity = this.cities.find(city => city.id === selectedId);
  }

  async proceed() {
    // console.log(this.selectedCity);
    await Preferences.set({ key: 'selectedCity', value: JSON.stringify(this.selectedCity) });
    this.modalController.dismiss({ selectedCity: this.selectedCity }, 'confirm');
  }

  async cancel() {
    if (!this.hasSelectedCity) {
      return;
    }

    this.modalController.dismiss(null, 'cancel');
  }
}
